import CryptoJS from 'crypto-js';
import dayjs from 'dayjs';
import { router } from '@/routers';
import { storeToRefs, useHot, useModalStore, useTenantStore, useUserStore } from '@star/stores';
import { GameBigTypesEnum, ModalTypeEnum } from '@star/constants';

const key = '0d3389d9dea66ae1';

const encrypt = text => {
  return CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(key), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
};

const decrypt = text => {
  let decrypted = CryptoJS.AES.decrypt(text, CryptoJS.enc.Utf8.parse(key), {
    mode: CryptoJS.mode.ECB,

    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const G_goLogin = async () => {
  const modalStore = useModalStore();
  modalStore.addPopupModal(ModalTypeEnum.LOGIN_REGISTER_MODAL, { type: 1 });
  router.replace({ path: '/home' }).then(() => {
    modalStore.initModal();
  });
};

export const G_goRegister = async (query?: Record<string, any>) => {
  const modalStore = useModalStore();
  modalStore.addPopupModal(ModalTypeEnum.LOGIN_REGISTER_MODAL, { type: 2 });
  router.replace({ path: '/home', query }).then(() => {
    modalStore.initModal();
  });
};

// 得到当前租户 如：17-6
export const getCurrentTenant = () => {
  const tenant = useTenantStore().tenantInfo;
  let tenant_clusters_id: any = tenant.clusters_id;
  let tenant_tid: any = tenant.tid;
  const localTenant = window.sessionStorage.getItem('CIDTID');
  if (localTenant) {
    return localTenant;
  }
  return `${tenant_clusters_id}-${tenant_tid}`;
};

// 判断当前租户是否为传入租户 如：17-6
export const isSpecialTenant = (clusters_id, tid) => {
  if (!clusters_id || !tid) {
    return false;
  }
  return `${clusters_id}-${tid}` === getCurrentTenant();
};

/**
 * 默認返回yyyy-MM-dd HH:mm:ss
 * @param timestamp
 * @param type
 */
export const dateFormat = (timestamp, type) => {
  if (!timestamp) {
    return;
  }
  const date = new Date(timestamp);
  const year = date.getFullYear();
  let month: any = date.getMonth() + 1;
  if (month < 10) {
    month = `0${month}`;
  }
  let day: any = date.getDate();
  if (day < 10) {
    day = `0${day}`;
  }
  let hour: any = date.getHours();
  if (hour < 10) {
    hour = `0${hour}`;
  }
  let minute: any = date.getMinutes();
  if (minute < 10) {
    minute = `0${minute}`;
  }
  let second: any = date.getSeconds();
  if (second < 10) {
    second = `0${second}`;
  }
  if (type === 'HH:mm') {
    return `${hour}:${minute}`;
  } else if (type === 'HH:mm:ss') {
    return `${hour}:${minute}:${second}`;
  } else if (type === 'MM-dd HH:mm') {
    return `${month}-${day} ${hour}:${minute}`;
  } else if (type === 'yyyy-mm-dd') {
    return `${year}-${month}-${day}`;
  } else {
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  }
};

export const dateFormatDayjs = (timestamp, type = 'YYYY-MM-DD HH:mm:ss') => {
  return dayjs(timestamp).format(type);
};

export const moveValueToFront = (arr, value) => {
  const _arr = [...arr];
  const index = _arr.indexOf(value);
  if (index !== -1) {
    _arr.splice(index, 1);
    _arr.unshift(value);
  }
  return _arr;
};

export const transferThirdGameUrl = (url, payload, info) => {
  const { userInfo } = storeToRefs(useUserStore());
  window.sessionStorage.setItem('THIRD_GAME_PLAY_ID', payload.play_id);
  window.sessionStorage.setItem('THIRD_GAME_PAYLOAD', JSON.stringify(payload));
  // https域名下内嵌http打不开,转一下
  const _protocol = document.location.protocol;
  if (_protocol === 'https:' && url.indexOf('http://') === 0) {
    url = url.replace('http://', 'https://');
  }
  console.log(payload, 'xxxxxxxxxxxxxxxxxxxxx', info);
  // 缓存玩的游戏
  let gameId = `${payload.play_id}-${payload?.data?.type || ''}`;
  let localKey = `RECENT_GAME_${userInfo.value.cust_id || ''}`;
  let localKeyPre = '';
  // 电子
  if (info.big_type === GameBigTypesEnum.ELECTRONIC) {
    localKeyPre = 'DZ';
  } else if (info.big_type === GameBigTypesEnum.FISHING) {
    localKeyPre = 'BY';
    gameId = `${payload.play_id}-${payload?.buyu_game_id}`;
  } else if (info.big_type === GameBigTypesEnum.CHESS) {
    localKeyPre = 'QP';
  } else if (info.big_type === GameBigTypesEnum.LOTTERY) {
    localKeyPre = 'ZR';
  } else if (info.big_type === GameBigTypesEnum.SPORTS) {
    localKeyPre = 'TY';
  } else if (info.big_type === GameBigTypesEnum.LOTTERY) {
    localKeyPre = 'CP';
  } else if (info.big_type === GameBigTypesEnum.BLOCK_THIRD) {
    localKeyPre = 'QKL';
  }
  gameId = `${localKeyPre}-${gameId}`;
  if (localKey) {
    const localData = localStorage.getItem(localKey);
    let recentLocal = localData ? localData.split(',') : [];
    if (recentLocal.includes(gameId)) {
      recentLocal = moveValueToFront(recentLocal, gameId + '');
    } else {
      recentLocal.unshift(gameId);
    }
    if (recentLocal.length > 20) {
      recentLocal.length = 20;
    }
    localStorage.setItem(localKey, recentLocal.join(','));
  }
  const live = [];
  const cp = [
    1536, // BBIN彩票
  ];
  const dz = [
    414, // pt
  ];
  if ([...live, ...dz, ...cp].includes(Number(payload.play_id))) {
    return {
      url,
      target: '_blank',
    };
  } else {
    window.sessionStorage.setItem('THIRD_GAME_URL', url);
    window.sessionStorage.setItem('BACK_URL_HASH', window.location.hash);
    return {
      url: `/#/iframe`,
      target: '_self',
    };
  }
};

const currencyMap = {
  BRL: 'pt-BR',
  // "CNY": "pt-BR",
};

export const currencyMoney = (money, digital = 2) => {
  const num = Number(money);

  const localArea = localStorage.getItem('PLATFORM_AREA') || '';
  let currency = '';
  if (currencyMap[localArea]) {
    currency = 'pt-BR';
  }
  if (currency) {
    return num.toLocaleString(currency, { maximumFractionDigits: digital });
  } else {
    return num ? num.toFixed(digital) : 0;
  }
};

export const groupArray = (array, subGroupLength = 3) => {
  let index = 0;
  let newArray = [];

  while (index < array.length) {
    newArray.push(array.slice(index, (index += subGroupLength)));
  }

  return newArray;
};

export const getTenantName = () => {
  const { hotData } = useHot();
  const { tenantInfo } = hotData;
  return tenantInfo.value.tenant.tenant_name;
};
